export const OrangeEllipse = () => (
  <svg width="138" height="82" viewBox="0 0 138 82" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="41" r="106" fill="url(#paint0_radial_1359_20725)" fillOpacity="0.11" />
    <defs>
      <radialGradient
        id="paint0_radial_1359_20725"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32 41) rotate(90) scale(106)"
      >
        <stop stopColor="#FFD426" />
        <stop offset="1" stopColor="#FFD426" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
